{
  "version": 1,
  "asset_id": "836c0684-e7a6-4d36-b79b-dc65e897b294",
  "project_id": "ca7587fa-3476-4974-b258-69992cc9166e",
  "url": "/__l5e/assets-v1/836c0684-e7a6-4d36-b79b-dc65e897b294/werk-4.jpg",
  "r2_key": "a/v1/ca7587fa-3476-4974-b258-69992cc9166e/836c0684-e7a6-4d36-b79b-dc65e897b294/werk-4.jpg",
  "original_filename": "werk-4.jpg",
  "size": 85484,
  "content_type": "image/jpeg",
  "created_at": "2026-09-22T13:30:04Z"
}
